import { Card, Form, Input, Switch, Select, Button, Spin, message, Divider } from "antd";
import { useAuth } from "~/store";
import { useOrganization, useUpdateOrganization } from "~/services/organization";
import { SubscriptionTier } from "~/utils/constants";
import { useEffect } from "react";

export const OrganizationSettings = () => {
  const { user } = useAuth();
  const orgId = user?.organizationId;
  const { data: org, isLoading } = useOrganization(orgId || "");
  const updateOrg = useUpdateOrganization();
  const [form] = Form.useForm();

  useEffect(() => {
    if (org) {
      form.setFieldsValue(org);
    }
  }, [org, form]);

  if (isLoading) return <Spin className="flex justify-center mt-20" />;
  if (!org) return <div className="p-6">No organization found</div>;

  const handleSave = async (values: any) => {
    try {
      await updateOrg.mutateAsync({ id: org.id, body: values });
      message.success("Organization updated");
    } catch {
      message.error("Failed to update organization");
    }
  };

  return (
    <div className="p-6 max-w-3xl">
      <h1 className="text-xl font-bold mb-6">Organization Settings</h1>

      <Card>
        <Form form={form} layout="vertical" onFinish={handleSave}>
          <Form.Item name="name" label="Organization Name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>

          <Form.Item name="slug" label="Slug (URL identifier)">
            <Input disabled />
          </Form.Item>

          <div className="grid grid-cols-2 gap-4">
            <Form.Item name="timezone" label="Timezone">
              <Select
                options={[
                  { value: "America/New_York", label: "Eastern (ET)" },
                  { value: "America/Chicago", label: "Central (CT)" },
                  { value: "America/Denver", label: "Mountain (MT)" },
                  { value: "America/Los_Angeles", label: "Pacific (PT)" },
                ]}
              />
            </Form.Item>

            <Form.Item name="subscriptionTier" label="Plan">
              <Select
                disabled={!org.isPlatformOwner}
                options={Object.values(SubscriptionTier).map((t) => ({
                  value: t,
                  label: t.charAt(0).toUpperCase() + t.slice(1),
                }))}
              />
            </Form.Item>
          </div>

          <Divider>Network Features</Divider>

          <Form.Item name="networkEnabled" label="Enable Network" valuePropName="checked">
            <Switch />
          </Form.Item>

          <p className="text-xs text-gray-500 mb-4">
            When enabled, your organization can share shuttle routes and receive job referrals from other art handling companies on the platform.
          </p>

          <Button type="primary" htmlType="submit" loading={updateOrg.isPending}
            className="bg-black hover:bg-gray-800 border-black">
            Save Changes
          </Button>
        </Form>
      </Card>
    </div>
  );
};
